import { useTranslation } from 'react-i18next';
import Buscador from './Buscador';
import Ofertas from './Ofertas';

const Cabecera = ({ lang, destinos, tiposcasas }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-video u-section-1 cabecera-home" id="block-8">
                <div className="u-background-video u-expanded" >
                    <div className="embed-responsive embed-responsive-1">
                        <iframe style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} className="embed-responsive-item" src="https://www.youtube.com/embed/IsWXj_fNDEM?playlist=IsWXj_fNDEM&amp;loop=1&amp;mute=1&amp;showinfo=0&amp;controls=0&amp;start=0&amp;autoplay=1" data-autoplay="1" allowFullScreen=""></iframe>
                    </div>
                    <div className="u-video-shading"></div>
                </div>
                <div className="u-clearfix u-sheet u-sheet-1">
                    {/*<Buscador
                        lang={lang}
                        destinos={destinos}
                        tiposcasas={tiposcasas}
                    />*/}
                    {/*<Ofertas
                        lang={lang}
                    />*/}
                </div>
            </section>
        </>
    );
}

export default Cabecera;
